import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import ThreeDots from "static/images/ThreeDots.svg";

type IncorporationTrackerActionsMenuProps = {
  isEditable: boolean;
  isPublished: boolean;
  onSaveAsBaseTemplate?: () => void;
  onRearrangeSteps: () => void;
  onDiscardTemplate: () => void;
  onUnpublish?: () => void;
};

export const IncorporationTrackerActionsMenu = ({
  isEditable,
  isPublished,
  onSaveAsBaseTemplate,
  onRearrangeSteps,
  onDiscardTemplate,
  onUnpublish,
}: IncorporationTrackerActionsMenuProps) => (
  <Dropdown.Root>
    <Dropdown.Trigger asChild>
      <Button type="button" customType="icon" size="small">
        <img src={ThreeDots} alt="Show more options" />
      </Button>
    </Dropdown.Trigger>
    <Dropdown.Portal>
      <Dropdown.Content sideOffset={6} align="end" className="!t-min-w-40">
        {onSaveAsBaseTemplate && (
          <Dropdown.Item onSelect={onSaveAsBaseTemplate}>
            Save as base template
          </Dropdown.Item>
        )}
        {isEditable && (
          <Dropdown.Item onSelect={onRearrangeSteps}>
            Rearrange template
          </Dropdown.Item>
        )}
        {!isPublished && (
          <Dropdown.Item type="danger" onSelect={onDiscardTemplate}>
            Discard template
          </Dropdown.Item>
        )}
        {isPublished && onUnpublish && (
          <Dropdown.Item type="danger" onSelect={onUnpublish}>
            Unpublish
          </Dropdown.Item>
        )}
      </Dropdown.Content>
    </Dropdown.Portal>
  </Dropdown.Root>
);
